import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreAuthDto } from './dto/pre-auth-dto';
import { PreAuthResponseDto } from './dto/pre-auth-response-dto';
import { RegisterDto } from './dto/register-dto';
import { RegisterResponseDto } from './dto/register-response-dto';
import { LoginDto } from './dto/login-dto';
import { LoginResponseDto } from './dto/login-response-dto';
import { UpdateProfileDto } from './dto/update-profile-dto';
import { ApiResponseDto } from '../tables/dto/api-response-dto';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  constructor(private http: HttpClient) { }

  preAuth(preAuthDto: PreAuthDto): Observable<PreAuthResponseDto> {
    return this.http.post<PreAuthResponseDto>(`auth/pre`, preAuthDto);
  }

  register(registerDto: RegisterDto): Observable<RegisterResponseDto> {
    return this.http.post<RegisterResponseDto>(`auth/register`, registerDto);
  }

  resendSms(countryCode: string, phone: string): Observable<ApiResponseDto>{
    return this.http.post<RegisterResponseDto>(`auth/resend`, {countryCode, phone});
  }

  login(loginDto: LoginDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`auth/login`, loginDto);
  }

  updateProfile(dto: UpdateProfileDto): Observable<any> {
    return this.http.patch<any>(`auth/profile`, dto);
  }
}
